import { bugsnagNotify } from '../researcher/util/bugsnag';

const MINIMUM_BROWSER_VERSIONS = {
  Chrome: 88,
  Firefox: 85,
  Safari: 14,
  Edge: 88,
  Opera: 74,
  Samsung: 15,
};

function parseUserAgent(userAgent) {
  const ua = userAgent.toLowerCase();

  if (ua.includes('fban') || ua.includes('fbav')) {
    return { name: 'Facebook', version: 999 };
  }

  if (/(iphone|ipad|ipod)/.test(ua)) {
    const osMatch = ua.match(/os (\d+)_/);
    if (osMatch) {
      return { name: 'Safari', version: parseInt(osMatch[1], 10) };
    }
    const versionMatch = ua.match(/version\/(\d+)/);
    return { name: 'Safari', version: versionMatch ? parseInt(versionMatch[1], 10) : 14 };
  }

  if (ua.includes('chrome') && !ua.includes('edge') && !ua.includes('edg/')) {
    const match = ua.match(/chrome\/(\d+)/);
    return { name: 'Chrome', version: match ? parseInt(match[1], 10) : 0 };
  }

  if (ua.includes('edg/')) {
    const match = ua.match(/edg\/(\d+)/);
    return { name: 'Edge', version: match ? parseInt(match[1], 10) : 0 };
  }

  if (ua.includes('firefox')) {
    const match = ua.match(/firefox\/(\d+)/);
    return { name: 'Firefox', version: match ? parseInt(match[1], 10) : 0 };
  }

  if (ua.includes('safari') && !ua.includes('chrome')) {
    const match = ua.match(/version\/(\d+)/);
    return { name: 'Safari', version: match ? parseInt(match[1], 10) : 0 };
  }

  if (ua.includes('samsungbrowser')) {
    const match = ua.match(/samsungbrowser\/(\d+)/);
    return { name: 'Samsung', version: match ? parseInt(match[1], 10) : 0 };
  }

  if (ua.includes('opr/')) {
    const match = ua.match(/opr\/(\d+)/);
    return { name: 'Opera', version: match ? parseInt(match[1], 10) : 0 };
  }

  return { name: 'Unknown', version: 0 };
}

function checkBrowserVersion() {
  try {
    const { name, version } = parseUserAgent(navigator.userAgent);
    const minVersion = MINIMUM_BROWSER_VERSIONS[name];

    if (!minVersion) {
      return name === 'Facebook';
    }

    if (version === 0) {
      return false;
    }

    return version >= minVersion;
  } catch (error) {
    return false;
  }
}

export const isCompatible = () => {
  try {
    return checkBrowserVersion();
  } catch (error) {
    bugsnagNotify(error, {
      context: 'Browser compatibility check failed',
      userAgent: navigator.userAgent,
    });

    return false;
  }
};
